import { registerMsgHandler } from "userful-chronos-app-common-js/dist/message/messageRegistery";
import { SamPlayListDef } from "userful-chronos-app-common-js/dist/models/sam/SAMPlaylist";
import { SamSourceDef } from "userful-chronos-app-common-js/dist/models/sam/SAMSource";
import { SamSourceSpec } from "userful-chronos-app-common-js/dist/models/sam/SAMSourceSpec";
import { playlistSliceActions } from "../../sourceassets/playlistSlice";
import { sourceSliceActions } from "../../sourceassets/sourceSlice";
import mappingStore from "../mappingStore";
import {
    NOTIFY_ADD_PLAYLIST_DEF,
    NOTIFY_ADD_SOURCE_DEF,
    NOTIFY_REMOVE_PLAYLIST_DEF,
    NOTIFY_REMOVE_SOURCE_DEF,
    NOTIFY_UPDATE_PLAYLIST_DEF,
    NOTIFY_UPDATE_SOURCE_DEF,
    NOTIFY_UPDATE_SOURCE_SPEC,
    REQUEST_QUERY_SOURCE_DEFS,
    RESPONSE_FIND_PLAYLIST_DEF,
    RESPONSE_FIND_SOURCE_DEF,
    RESPONSE_LIST_PLAYLIST_DEFS,
    RESPONSE_LIST_SOURCE_DEFS,
    RESPONSE_LIST_SOURCE_SPECS,
    RESPONSE_QUERY_PLAYLIST_DEFS,
    RESPONSE_REMOVE_PLAYLIST_DEF,
    RESPONSE_REMOVE_SOURCE_DEF,
    RESPONSE_UPDATE_PLAYLIST_DEF,
    RESPONSE_UPDATE_SOURCE_DEF,
} from "../../sourceassets/msgs/SAMMsgDefinations";
import { filterAppExclusiveSource, updateSamItemMatchesAppID } from "../StoreFilters";
import {
    setReceivedInitialSAMPlaylist,
    setReceivedInitialSAMPlaylistQuery,
    setReceivedInitialSAMSource,
    setReceivedInitialSAMSourceQuery,
    setReceivedInitialSourceSpecs,
} from "../../InitialDataStates";
import { SamUsageDataResponse } from "userful-chronos-app-common-js/dist/models/sam/Common";
import { isSourceAllowedInCurrentApp } from "userful-chronos-app-common-js/dist/models/sam/AppSourceTypeFilter";
import { sourceEditSliceActions } from "../../sourceassets/sourceEditSlice";

let appID = null;
export const setAppIDForMappingSamReceiver = (appIDValue: string) => {
    appID = appIDValue;
};

//
registerMsgHandler(RESPONSE_QUERY_PLAYLIST_DEFS, (payload) => {
    setReceivedInitialSAMPlaylistQuery();
    console.debug("receive RESPONSE_QUERY_PLAYLIST_DEFS");
    const data = JSON.parse(payload) as Array<SamPlayListDef>;
    mappingStore.dispatch(playlistSliceActions.setPlaylists(data));
});
registerMsgHandler(RESPONSE_LIST_PLAYLIST_DEFS, (payload) => {
    setReceivedInitialSAMPlaylist();
    if (appID) {
        return;
    }
    console.debug("receive RESPONSE_LIST_PLAYLIST_DEFS");
    const data = JSON.parse(payload) as Array<SamPlayListDef>;
    mappingStore.dispatch(playlistSliceActions.setPlaylists(data));
});
registerMsgHandler(RESPONSE_FIND_PLAYLIST_DEF, (payload) => {
    console.debug("receive RESPONSE_FIND_PLAYLIST_DEF");
    const data = JSON.parse(payload) as SamPlayListDef;
});
registerMsgHandler(NOTIFY_ADD_PLAYLIST_DEF, (payload) => {
    console.debug("receive NOTIFY_ADD_PLAYLIST_DEF");
    const data = JSON.parse(payload) as SamPlayListDef;
    if (!updateSamItemMatchesAppID(data, appID)) {
        console.debug("No appID match");
        return;
    }
    mappingStore.dispatch(playlistSliceActions.addPlaylist(data));
});
registerMsgHandler(NOTIFY_UPDATE_PLAYLIST_DEF, (payload) => {
    console.debug("receive NOTIFY_UPDATE_PLAYLIST_DEF");
    const data = JSON.parse(payload) as SamPlayListDef;
    if (!updateSamItemMatchesAppID(data, appID)) {
        console.debug("No appID match");
        mappingStore.dispatch(playlistSliceActions.deletePlaylist(data.id.value));
        return;
    }
    mappingStore.dispatch(playlistSliceActions.updatePlaylist(data));
    if (appID) {
        mappingStore.dispatch(playlistSliceActions.addPlaylist(data));
    }
});
registerMsgHandler(NOTIFY_REMOVE_PLAYLIST_DEF, (payload) => {
    console.debug("receive NOTIFY_REMOVE_PLAYLIST_DEF");
    const data = JSON.parse(payload) as SamPlayListDef;
    mappingStore.dispatch(playlistSliceActions.deletePlaylist(data.id.value));
});
registerMsgHandler(RESPONSE_UPDATE_PLAYLIST_DEF, (payload) => {
    console.debug("receive RESPONSE_UPDATE_PLAYLIST_DEF");
    const data = JSON.parse(payload) as SamUsageDataResponse;
    mappingStore.dispatch(playlistSliceActions.receiveUpdateOrDeletePlaylistResponse(data));
});

registerMsgHandler(RESPONSE_REMOVE_PLAYLIST_DEF, (payload) => {
    console.debug("receive RESPONSE_REMOVE_PLAYLIST_DEF");
    const data = JSON.parse(payload) as SamUsageDataResponse;
    mappingStore.dispatch(playlistSliceActions.receiveUpdateOrDeletePlaylistResponse(data));
});

//
registerMsgHandler(REQUEST_QUERY_SOURCE_DEFS, (payload) => {
    console.debug("receive REQUEST_QUERY_SOURCE_DEFS");
    setReceivedInitialSAMSourceQuery();
    const data = JSON.parse(payload) as Array<SamSourceDef>;
    mappingStore.dispatch(sourceSliceActions.setSources(data.filter((s) => isSourceAllowedInCurrentApp(s, appID))));
});
registerMsgHandler(RESPONSE_LIST_SOURCE_DEFS, (payload) => {
    setReceivedInitialSAMSource();
    if (appID) {
        return;
    }
    console.debug("receive RESPONSE_LIST_SOURCE_DEFS");
    const data = JSON.parse(payload) as Array<SamSourceDef>;
    mappingStore.dispatch(sourceSliceActions.setSources(filterAppExclusiveSource(data)));
});
registerMsgHandler(RESPONSE_FIND_SOURCE_DEF, (payload) => {
    const data = JSON.parse(payload) as SamSourceDef;
});
registerMsgHandler(NOTIFY_ADD_SOURCE_DEF, (payload) => {
    console.debug("receive NOTIFY_ADD_SOURCE_DEF");
    const data = JSON.parse(payload) as SamSourceDef;
    mappingStore.dispatch(sourceEditSliceActions.sourceAdded(data));
    if (!updateSamItemMatchesAppID(data, appID) || !isSourceAllowedInCurrentApp(data, appID)) {
        console.debug("No appID match");
        return;
    }
    mappingStore.dispatch(sourceSliceActions.addSource(data));
    mappingStore.dispatch(sourceEditSliceActions.sourceAdded(data));
});
registerMsgHandler(NOTIFY_UPDATE_SOURCE_DEF, (payload) => {
    console.debug("receive NOTIFY_UPDATE_SOURCE_DEF");
    const data = JSON.parse(payload) as SamSourceDef;
    mappingStore.dispatch(sourceEditSliceActions.sourceUpdated(data));
    if (!updateSamItemMatchesAppID(data, appID) || !isSourceAllowedInCurrentApp(data, appID)) {
        console.debug("No appID match");
        mappingStore.dispatch(sourceSliceActions.deleteSource(data.id.value));
        return;
    }
    mappingStore.dispatch(sourceEditSliceActions.sourceUpdated(data));
    mappingStore.dispatch(sourceSliceActions.updateSource(data));
    if (appID) {
        mappingStore.dispatch(sourceSliceActions.addSource(data));
    }
});
registerMsgHandler(NOTIFY_REMOVE_SOURCE_DEF, (payload) => {
    console.debug("receive NOTIFY_REMOVE_SOURCE_DEF");
    const data = JSON.parse(payload) as SamSourceDef;
    mappingStore.dispatch(sourceSliceActions.deleteSource(data.id.value));
});
registerMsgHandler(RESPONSE_UPDATE_SOURCE_DEF, (payload) => {
    console.debug("receive RESPONSE_UPDATE_SOURCE_DEF");
    const data = JSON.parse(payload) as SamUsageDataResponse;
    mappingStore.dispatch(sourceSliceActions.receiveUpdateOrDeletePlaylistResponse(data));
    mappingStore.dispatch(sourceEditSliceActions.receiveUpdateSourceResponse(data));
});
registerMsgHandler(RESPONSE_REMOVE_SOURCE_DEF, (payload) => {
    console.debug("receive RESPONSE_REMOVE_SOURCE_DEF");
    const data = JSON.parse(payload) as SamUsageDataResponse;
    mappingStore.dispatch(sourceSliceActions.receiveUpdateOrDeletePlaylistResponse(data));
});

//
registerMsgHandler(RESPONSE_LIST_SOURCE_SPECS, (payload) => {
    setReceivedInitialSourceSpecs();
    console.debug("receive RESPONSE_LIST_SOURCE_SPECS");
    const data = JSON.parse(payload) as Array<SamSourceSpec>;
    mappingStore.dispatch(sourceSliceActions.setSourceSpecs(data));
});
registerMsgHandler(NOTIFY_UPDATE_SOURCE_SPEC, (payload) => {
    console.debug("receive NOTIFY_UPDATE_SOURCE_SPEC");
    const data = JSON.parse(payload) as SamSourceSpec;
    mappingStore.dispatch(sourceSliceActions.addOrUpdateSourceSpec(data));
});
